import React from 'react';
import ImageItem from './imageItem';

type TImagesProps = {
  images: Array<IUploadImage>;
  setFile: React.Dispatch<React.SetStateAction<IUploadImage[]>>;
  setOldImages?: React.Dispatch<React.SetStateAction<IOldImage[]>>;
};
const Images = ({images, setFile, setOldImages}: TImagesProps) => {
  return (
    <>
      {React.Children.toArray(
        images?.map(item => (
          <ImageItem
            setOldImages={setOldImages}
            image={item}
            setFile={setFile}
          />
        )),
      )}
    </>
  );
};

export default Images;
